import { campfireThemeExtendedOptions } from '../../../../theme/src';

export interface IncomingStatusInput {
  applicationStatus?: string | null;
  profileId?: string | null;
  inviteeId?: string | null;
  dateRevoked?: string | null;
  dateRemoved?: string | null;
  isCompleted?: boolean | null;
  isProfileTaskApproved?: boolean | null;
  hasPendingTasks?: boolean | null;
  status?: string | null;
}

export interface IncomingStatusChip {
  label: string;
  color: string;
}

export const isAwaitingScreeningReview = (applicationStatus?: string | null) => applicationStatus === 'pending';

const hasScreeningReview = (input: IncomingStatusInput) => isAwaitingScreeningReview(input.applicationStatus);

const deriveStatus = (input: IncomingStatusInput): string | undefined => {
  if (input.status) return input.status;

  const screening = hasScreeningReview(input);

  if (input.profileId) {
    if (input.dateRemoved) return 'inactive';
    if (input.hasPendingTasks || screening) return 'pending_review';
    if (input.isCompleted && input.isProfileTaskApproved) return 'ready';
    if (input.isCompleted) return 'active';
    return 'pending';
  }

  if (input.applicationStatus === 'rejected' || input.applicationStatus === 'removed') return 'inactive';
  if (screening) return 'pending_review';
  return input.applicationStatus ? 'active' : undefined;
};

export const getIncomingStatusChips = (input: IncomingStatusInput): Array<IncomingStatusChip> => {
  const status = deriveStatus(input);
  const screening = hasScreeningReview(input);

  const isApplicationDeleted = ['rejected', 'removed'].includes(input.applicationStatus || '');
  const isProfileRemoved = Boolean(input.profileId) && status === 'inactive';
  const isInviteeRemoved = Boolean(input.inviteeId) && Boolean(input.dateRevoked);

  const chips: Array<IncomingStatusChip> = [];

  if (isApplicationDeleted || isProfileRemoved || isInviteeRemoved) {
    chips.push({ label: 'Removed', color: campfireThemeExtendedOptions.status.red.medium });
  }
  if (screening) {
    chips.push({ label: 'Screening', color: '#64B5F6' });
  }
  if (input.profileId && !input.isCompleted && !screening) {
    chips.push({ label: 'Profile', color: '#42A5F5' });
  }
  if (input.isCompleted && !screening) {
    chips.push({ label: 'Tasks', color: '#2196F3' });
  }
  if (status === 'pending_review') {
    chips.push({ label: 'Pending review', color: '#FF9800' });
  }
  if (status === 'ready') {
    chips.push({ label: 'Ready', color: '#4CAF50' });
  }

  return chips;
};
